<template>

    <div>
        <div class="flex justify-center items-center w-full" v-if="uploader.state.uploading === false">
            <label :for="id" class="flex flex-col justify-center items-center w-full h-32 bg-slate-50 rounded-lg border-2 border-slate-300 border-dotted cursor-pointer dark:hover:bg-bray-800 dark:bg-slate-700 hover:bg-slate-100 dark:border-slate-600 dark:hover:border-slate-500 dark:hover:bg-slate-600">
                <div class="flex flex-col justify-center items-center pt-5 pb-6">
                    <svg class="mb-3 w-10 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                    </svg>
                    <p class="mb-2 text-sm text-slate-500 dark:text-slate-400">Click to upload <span class="font-semibold">{{ label }}</span> (or drag and drop)</p>
                    <p class="text-xs text-slate-500 dark:text-slate-400">
                        <slot></slot>
                    </p>
                </div>

                <input type="file" :name="name" :id="id" class="invisible" ref="file" @change="handleFile">
            </label>
        </div>
        <div v-else>
            <div class="flex justify-between mb-1">
                <span class="text-base font-medium text-brand-500">{{ uploader.file.name }}</span>
                <span class="text-sm font-medium text-brand-500">{{ uploader.state.uploadProgress }}%</span>
            </div>
            <div class="w-full bg-slate-200 rounded-full h-2.5">
                <div class="bg-brand-500 h-2.5 rounded-full" :style="`width: ${uploader.state.uploadProgress}%`"></div>
            </div>
        </div>
        <input type="hidden" :name="name + '[uuid]'" :value="value.data[id].uuid">
        <input type="hidden" :name="name + '[key]'" :value="value.data[id].key">
        <input type="hidden" :name="name + '[bucket]'" :value="value.data[id].bucket">
        <input type="hidden" :name="name + '[file_name]'" :value="value.data[id].file_name">
        <input type="hidden" :name="name + '[content_type]'" :value="value.data[id].content_type">
    </div>

</template>

<script>
import {defineComponent} from "vue";
import {S3FileUpload} from "../../app/Support/S3FileUpload";

export default defineComponent({
    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            required: false,
            default: "File Upload"
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        id: {
            type: String,
            required: false,
            default: 'file_upload'
        },
        name: {
            type: String,
            required: false,
            default: 'file_upload'
        }
    },
    data() {
        return {
            uploader: new S3FileUpload(this.id),
        }
    },
    methods: {
        handleFile() {
            let vm = this;

            vm.uploader
                .upload(vm.$refs.file.files[0])
                .then(() => {
                    vm.value.data[vm.id].uuid = vm.uploader.data.uuid;
                    vm.value.data[vm.id].key = vm.uploader.data.key;
                    vm.value.data[vm.id].bucket = vm.uploader.data.bucket;
                    vm.value.data[vm.id].file_name = vm.uploader.data.file_name;
                    vm.value.data[vm.id].content_type = vm.uploader.data.content_type;
                });
        }
    }
});
</script>
